import React, { useState } from 'react';
import { connect } from 'react-redux';
import { IoIosArrowDown, IoIosArrowUp, IoIosClose } from 'react-icons/io';
import s from './style.css';
import UploadItem from './UploadItem';
import { vault } from '../../actions';
const UploadMenu = (props) => {
    const [collapsed, setCollapsed] = useState(false);
    if (!props.showMenu)
        return null;
    const Arrow = collapsed ? IoIosArrowUp : IoIosArrowDown;
    const { uploadingCount, uploadedCount } = props;
    const title = uploadingCount > 0
        ? `Uploading ${uploadingCount} item${uploadingCount > 1 ? 's' : ''}`
        : `${uploadedCount} upload${uploadedCount > 1 ? 's' : ''} complete`;
    return (React.createElement("div", { className: s.container },
        React.createElement("div", { className: s.titleContainer },
            React.createElement("p", { className: s.title }, title),
            React.createElement("div", { className: s.buttonsContainer },
                React.createElement(Arrow, { fontSize: 20, onClick: () => setCollapsed(!collapsed), className: s.button }),
                React.createElement(IoIosClose, { fontSize: 28, style: { marginLeft: '6px' }, className: s.button, onClick: () => props.hideUploadMenu() }))),
        React.createElement("div", { className: s.itemsContainer, style: { maxHeight: collapsed ? 0 : 200, paddingBottom: collapsed ? 0 : 10 } }, props.files.map((file) => (React.createElement(UploadItem, { file: file, key: file.uriKey }))))));
};
const mapStateToProps = (state) => {
    const { showMenu, files, ...uploadData } = state.upload;
    let uploadedCount = 0;
    Object.values(uploadData).forEach((value) => {
        if (value === 1)
            uploadedCount += 1;
    });
    return {
        showMenu,
        files,
        uploadingCount: state.upload.count,
        uploadedCount,
    };
};
const connector = connect(mapStateToProps, { ...vault });
export default connector(UploadMenu);
